import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleTag, SecurityModuleName, SecurityRight } from '../security.module';

export enum LocationSecurityRight {
    CanAccess = 29000,
}

export class LocationSecurityModule extends BaseSecurityModule<LocationSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Locations,
            [
                { _id: LocationSecurityRight.CanAccess, name: 'Access', basic: true },
            ] as SecurityRight<LocationSecurityRight>[]
        );

        this.plan = TenantSubscription.Core;
        this.tags = [SecurityModuleTag.Experimental];
    }


}
